
import React from "react";
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

import 'bootstrap/dist/css/bootstrap.min.css';
import './css-js/style.css';
import './css-js/responsive.css';
import 'jquery/dist/jquery.min.js';
import 'popper.js/dist/umd/popper.min.js';
import 'bootstrap/dist/js/bootstrap.min.js';

import Main from "./Main";
import About from "./About";
import Services from "./Services";
import Contact from "./Contact";
import PrivacyPolicy from "./privacy-policy";

// service
import LocalMoving from "./services/local-moving";
import CommercialMoving from "./services/commercial-moving";
import LongDistanceMoving from "./services/long-distance-moving";
import FullPacking from './services/full-packing';
import MovingTips from "./moving-tips";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Main />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/contact" element={<Contact />} />
        {/* services */}
        <Route path="/local-moving" element={<LocalMoving />} />
        <Route path="/commercial-moving" element={<CommercialMoving />} />
        <Route path="/long-distance-moving" element={<LongDistanceMoving />} />
        <Route path="/full-packing" element={<FullPacking />} />
        {/* Other pages */}
        <Route path="/moving-tips" element={<MovingTips />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      </Routes>
    </Router>
  );
}

export default App;
